export default __webpack_public_path__ + "static/media/bg1.3d2effc6.png";